export const BASE_URL_API = "https://sm.lokaci.com/andromeda/apis"